import * as React from 'react'
import classNames from 'classnames'

import { Text, TextName } from '../../sdk/text/Text'
import classes from './style.module.scss'
import plusIcon from './assets/plus.svg'

interface AccordionItemProps {
  title: string
  description: React.ReactNode
  className?: string
}

export const AccordionItem: React.FC<AccordionItemProps> = (props) => {
  const {
    title,
    description,
    className,
  } = props

  const [isExpanded, setIsExpanded] = React.useState(false)

  const handleToggle = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={classNames(classes.item, className)}>
      <div className={classes.header} onClick={handleToggle}>
        <Text type={TextName.Text}>{title}</Text>
        <img 
          src={plusIcon} 
          alt="toggle" 
          className={classNames(classes.icon, { [classes.iconExpanded]: isExpanded })}
        />
      </div>
      <div className={classNames(classes.content, { [classes.contentExpanded]: isExpanded })}>
        <div className={classes.contentInner}>
          {description}
        </div>
      </div>
    </div>
  )
}